/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2NvbXBvbmVudHMvc3RhdGlzdGljcy9kb25hdGlvbi9sb2dpc3RpY3MtZGVwdHMtZGV0YWlsL2xvZ2lzdGljcy1kZXB0cy1kZXRhaWwuY29tcG9uZW50LnNjc3MifQ== */"];
export { styles as styles };
